webpackJsonp([27804663203706],{

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ProjectPage = __webpack_require__(9);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var projectElements = {
		images: [{
			"src": "Schreibtherapie/past_1",
			"orientation": "landscape"
		}, {
			"src": "Schreibtherapie/past_2",
			"orientation": "landscape"
		}, {
			"src": "Schreibtherapie/past_3",
			"orientation": "landscape"
		}, {
			"src": "Schreibtherapie/past_4",
			"orientation": "landscape"
		}, {
			"src": "Schreibtherapie/past_5",
			"orientation": "landscape"
		}, {
			"src": "Schreibtherapie/past_6",
			"orientation": "landscape"
		}]
	};
	
	var Schreibtherapie = function (_React$Component) {
		_inherits(Schreibtherapie, _React$Component);
	
		function Schreibtherapie() {
			_classCallCheck(this, Schreibtherapie);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Schreibtherapie.prototype.render = function render() {
			return _react2.default.createElement(_ProjectPage2.default, {
				title: 'Schreibtherapie',
				text: 'Schreibtherapie ist kein Projekt, bei welchem es grunds\xE4tzlich darum geht sch\xF6ne Bilder zu pr\xE4sentieren. Viel eher will ich mit diesem Projekt ausdr\xFCcken, wie wichtig es ist auf sich selbst zu achten. \n\nDie Bilder zeigen eine fotografische Umsetzung meiner Journal-Eintr\xE4ge, welche vor, w\xE4hrend und nach meiner Psychotherapie entstanden sind. In der Therapie habe ich es geschafft mich selbst wieder zu verstehen und gelernt wie ich meine \xC4ngste z\xFCgeln kann. Dank den vielen Stunden, die ich auf dieser schwarzen Ledercouch verbracht habe, kann ich mich selbst und meine Zukunft selbstsicher und gl\xFCcklich entdecken. Dabei hat mir vor allem auch das Schreiben geholfen. Es geht hier nicht um ein Tagebuch in welches man jeden Tag hineinschreibt und erz\xE4hlt wie sch\xF6n das Wetter nicht war. Es geht vielmehr darum, die eigenen inneren Erlebnisse und Gef\xFChle niederzuschreiben. \n\nSchon l\xE4nger wollte ich dieses Projekt verwirklichen, um mit dieser Vergangenheit auch auf kreativem Wege abzuschlie\xDFen und um zu zeigen, dass man sich f\xFCr seine Schw\xE4chen nicht sch\xE4men muss und das Gute am Ende immer gewinnt.',
				images: projectElements.images,
				layout: 'einser' });
		};
	
		return Schreibtherapie;
	}(_react2.default.Component);
	
	exports.default = Schreibtherapie;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-past-js-7afc5b1962c0dbb12989.js